import {React} from 'external/react'
import {Box, styled, Select as MuiSelect, FormControl, FormHelperText, MenuItem, InputLabel} from 'external/material'

import {pickAttributes} from 'helpers/utils'

const StyledSelect = styled(Box)(selectStyles)

export default function Select (props) {

  const controlAttributes = pickAttributes(props, 'control')
  const selectAttributes = pickAttributes(props, 'select')

  const errorId = `${props.id}-error-text`
  const labelId = `${props.id}-label`

  return (
    <StyledSelect className={props?.customClassName ?? ''}>
      <Box className="label">{props.caption}</Box>
      <Box className="input">
        <FormControl
          {...controlAttributes}
          className="control"
        > 
          <MuiSelect
            labelId={labelId}
            id={props.id}
            {...selectAttributes}
            className="select"
          >
            {props.options.map((option, key) => (
              <MenuItem value={props.mapValue(option)} key={key}>{props.mapText(option)}</MenuItem>)
            )}
          </MuiSelect>
          <FormHelperText id={errorId} {...pickAttributes(props, 'error')}>{props.errorMessage}</FormHelperText>
        </FormControl>
      </Box>
    </StyledSelect>
  )
}

function selectStyles(theme) {
  return {
    "& .control": {
      margin: 0,
      flexGrow: 1
    }
  }
}

